<script setup lang="ts">
interface Props {
  submit_text?: string;
  disabled?: boolean;
}

const props = defineProps<Props>();
const emits = defineEmits(["submit"]);
function onClick() {
  if (props.disabled) return;
  emits("submit");
}
</script>

<template>
  <div class="w-full flex flex-col justify-center items-center relative gap-4">
    <button
      :type="disabled ? 'button' : 'submit'"
      class="w-fit bg-famitei-green text-white rounded-lg px-8 py-4 hover:bg-green-800"
      :class="{ 'opacity-50 cursor-not-allowed': disabled }"
      @click="onClick"
    >
      {{ submit_text }}
    </button>
    <slot />
  </div>
</template>
